
<style scoped>
    .Field {
        padding: 0.25rem;
    }

    .Field label input {
        margin-right: 0.5rem;
    }

    /* .Field label {
                    display: flex;
                    white-space: nowrap;
                    overflow: hidden; */
    /* text-overflow: ellipsis;
                } */

    /* .Field label span {
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                } */
</style>


<template lang="pug">

.MultipleChoice.flex.col( ref="Component" )

    .Field( v-for="item,i in data.items" :key="item.value" )
        //- :required="data.required||false"
        //- input( :ref="SetItemRef" :type="data.type" :name="data.name" :id="id+i" :value="item.value" @change="OnChange( $event, i )"  )
        //- label( :for="id+i" ) {{ item.label }}

        label
            input( :ref="SetItemRef" :type="data.type" :name="data.name" :value="item.value" v-model="inputs[index]" :required="data.required" )
            span {{ item.label.replace( /\//g, ' / ' ) }}

    //- input( type="radio" name="entry.1313414293_sentinel" id="e2" value="Dickes Haar" )
    //- label( for="e2" ) Dickes Haar

    //- input( type="radio" name="entry.1313414293_sentinel" id="e3" value="Normales Haar" )
    //- label( for="e3" ) Normales Haar

</template>


<script>

import { defineComponent, ref, reactive, onBeforeUpdate, onUpdated, onBeforeMount, onMounted } from 'vue'

import useState from '../state'

export default defineComponent( {

    name: 'MultipleChoice',

    props: ['index', 'data', /*'type', 'name', 'items'*/],

    setup( props, ctx ) {

        let refs = []

        const SetItemRef = el => {
            // console.log( 'SetItemRef > el:', el )
            refs.push( el )
        }

        onBeforeUpdate( () => {
            refs = []
        } )

        onUpdated( () => {
            // console.log( refs )
        } )



        const Component = ref( null )

        // const Fields = ref( null )

        const id = ref( `e-${ props.index }-` )

        const { form, inputs } = useState()

        // const OnChange = ( ev, i ) => {

        //     const index = props.index - 1

        //     console.log( 'OnChange > index:', index )
        //     console.log( 'OnChange > i:', i )
        //     console.log( 'OnChange > id:', id.value )
        //     console.log( 'OnChange > ev:', ev )
        //     // console.log( 'OnChange > ctx:', ctx )
        //     // console.log( 'OnChange > Component:', Component.value )
        //     // console.dir( Component.value )

        //     if( props.type === 'radio' ) {

        //         form.data[index] = {
        //             index: i,
        //             value: props.data.items[i].value,
        //         }

        //     } else {

        //         console.log( 'OnChange > refs:', refs )

        //         form.data[index] = props.data.items.reduce( ( acc, item, _i ) => {

        //             if( refs[_i].checked ) {

        //                 acc.push( {
        //                     index: _i,
        //                     value: item.value,
        //                 } )

        //             }

        //             return acc

        //         }, [] )

        //     }



        // }





        return {
            Component, refs, SetItemRef, id, inputs,
        }

    },

} )
</script>